import React, { useState, useCallback } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import { ToastProvider } from './components/Toast';
import Dashboard from './pages/Dashboard';
import Applications from './pages/Applications';
import Approvals from './pages/Approvals';
import Emergency from './pages/Emergency';
import Officers from './pages/Officers';
import Hospitals from './pages/Hospitals';
import AuditLogs from './pages/AuditLogs';
import Settings from './pages/Settings';
import Reports from './pages/Reports';
import Login from './pages/Login';
import { getToken, clearToken } from './services/api';
import './App.css';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(() => !!getToken());

  const handleLogin = useCallback(() => {
    setIsAuthenticated(true);
  }, []);

  const handleLogout = useCallback(() => {
    clearToken();
    setIsAuthenticated(false);
  }, []);

  if (!isAuthenticated) {
    return <Login onLogin={handleLogin} />;
  }

  return (
    <ToastProvider>
      <BrowserRouter>
        <div className="app">
          <Sidebar onLogout={handleLogout} />
          <main className="main">
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/applications" element={<Applications />} />
              <Route path="/approvals" element={<Approvals />} />
              <Route path="/emergency" element={<Emergency />} />
              <Route path="/officers" element={<Officers />} />
              <Route path="/hospitals" element={<Hospitals />} />
              <Route path="/reports/:reportType" element={<Reports />} />
              <Route path="/audit" element={<AuditLogs />} />
              <Route path="/settings" element={<Settings />} />
            </Routes>
          </main>
        </div>
      </BrowserRouter>
    </ToastProvider>
  );
}

export default App;
